
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import Head from "next/head";
import { Box, Flex } from "rebass/styled-components";
import Layout from "../components/Layout";
import useTranslation from "next-translate/useTranslation";
import Gallery from "../components/sitterprofile/Gallery";
import Avatar from "../components/dogprofile/Avatar";
import Observation from "../components/dogprofile/Observation";
import About from "../components/dogprofile/About";
import Review from "../components/dogprofile/Review";
import Stats from "../components/dogprofile/Stats";
import OtherCities from "../components/sitterprofile/OtherCities";
import { addApolloState, initializeApollo } from "../lib/apolloClient";
import { GetServerSideProps } from "next";
import { useGetDogProfileQuery, GetDogProfileDocument } from "../generated/graphql";
import CareInfo from "../components/dogprofile/CareInfo";
interface Props {
    query: Record<string, any>;
}
function DogProfile({ query }: Props) {
    const { id } = query;
    const { t } = useTranslation("dogprofile");
    const { data } = useGetDogProfileQuery({
        variables: { id: id }
    });
    const dog = data && data.dog;
    return (<Layout title={t("title", {
            dog: dog?.name,
            breed: dog?.breed?.tName,
            owner: dog?.user.name
        })}>
      <Head>
        <meta name="robots" content="noindex,follow"/>
      </Head>

      {dog && (<Box itemScope itemType="http://schema.org/Product">
          <Box width={[1, 1, 5 / 6]} mx="auto" pb={6} variant="layout.large">
            <Flex sx={{
                flexDirection: ["column", "column", "row"],
                justifyContent: "center",
                flexWrap: "wrap"
            }}>
              <Box width={[1, 1, 2 / 5]} pl={[0, 0, 3]} pr={[0, 0, 2]}>
                <Avatar dog={dog}/>
              </Box>
              <Box width={[1, 1, 3 / 5]}>
                <Observation dog={dog}/>

                {!!dog.photos.length && (<Box mt={3}>
                    <Gallery photos={dog.photos} limit={4} imagePriority></Gallery>
                  </Box>)}
                <About dog={dog}/>
                <Stats dog={dog}/>
                <CareInfo dog={dog}/>
                <Review dog={dog}/>
              </Box>
            </Flex>
          </Box>
          {dog.user?.city && (<Box variant="layout.large" pb={5} sx={{
                    borderTop: "default"
                }}>
              <OtherCities city={dog.user.city}/>
            </Box>)}
        </Box>)}
    </Layout>);
}
const getServerSideProps: GetServerSideProps = async (context) => {
    const { query, locale, req } = context;
    const apolloClient = initializeApollo(locale, req);
    try {
        await apolloClient.query({
            query: GetDogProfileDocument,
            variables: query
        });
        return addApolloState(apolloClient, {
            props: {
                locale,
                query
            }
        });
    }
    catch (error) {
        if (error.graphQLErrors?.length > 0 &&
            error.graphQLErrors[0]?.extensions?.code === "NOT_FOUND") {
            return {
                notFound: true
            };
        }
        throw error;
    }
};
export default DogProfile;

    async function __Next_Translate__getServerSideProps__196cfbd51e3__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/dogprofile',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__196cfbd51e3__ as getServerSideProps }
  